import "core-js/modules/es.array.push.js";
import { mapState } from 'vuex';
import Bus from '@/assets/js/bus.js';
export default {
  props: {
    anywherePopShow: Boolean,
    devicePlatform: [String, Number],
    degreeHost: [String, Number],
    nickName: String,
    avatar: String,
    tagName: String,
    userInfo: Object,
    talkbackStatus: Boolean,
    fullScreenInfo: Boolean,
    talkBackInfo: Object,
    isAudioLevel: {
      type: Boolean,
      default() {
        return true;
      }
    },
    controlMute: {
      default: ''
    },
    devicesInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    outputRtilCode: {
      type: [String, Number],
      default: ''
    },
    selectRids: {
      type: String,
      default: ''
    },
    allRList: {
      type: Object,
      default: () => {
        return {};
      }
    },
    singChannel: {
      type: Object,
      default: () => {
        return {};
      }
    },
    title: {
      type: String,
      default: null
    },
    theme: {
      type: String,
      validator: function (value) {
        if (['success', 'danger'].includes(value)) {
          return value;
        }
        return '';
      }
    },
    muteVideo: {
      // 是否默认关闭摄像头
      type: Boolean,
      default: true
    },
    muteAudio: {
      // 是否默认静音
      type: Boolean,
      default: true
    },
    liveInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    needStartVoip: {
      type: Boolean,
      default: false
    },
    sourceId: {
      type: String,
      default: ''
    },
    rtc: {
      type: Object,
      default: () => {
        return {};
      }
    },
    remoteNetWorks: {
      type: Object,
      default: () => {
        return {};
      }
    },
    hearSelf: {
      type: Boolean,
      default: false
    },
    sourceType: {
      type: String,
      default: ''
    },
    rtilCodeList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    leftRightRtilCode: {
      type: [Number, String],
      default: ''
    },
    pipVolume: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      getReceiverParams: {
        pageNum: 1,
        pageSize: 400,
        living: true,
        offline: false,
        online: true,
        queryCollaborate: true
      },
      getRListTimer: null,
      selectPip: false,
      receiverList: [],
      origin: '',
      tvuOne: false,
      selectRid: '',
      isFullScreen: false,
      listInfo: {}
    };
  },
  created() {
    Bus.$on('selectAllPipMove', v => {
      // 只对目前已有的与会者进行操作，后加入的不处理
      if (v.type == 'all') {
        this.selectPip = v.status;
        if (this.btnList.includes('moveParty')) {
          this.$emit('operatCallback', {
            type: 'moveParty',
            id: this.singChannel.id,
            status: v.status,
            sign: 'batch'
          });
        }
      }
    });
    if (this.allRList) {
      if (this.$route.name == 'party' || this.$route.name == 'partyParticipate') {
        this.newFormatRList(this.allRList, true);
      } else {
        this.formatRList(this.allRList, true);
      }
    }
  },
  computed: {
    ...mapState({
      State: state => state
    }),
    btnList() {
      let array = ['rename', 'editTagName', 'moveParty', 'mainwindow', 'removeParticipant', 'setting'];
      if (this.singChannel.info) {
        this.State.v3List.forEach(item => {
          if (this.singChannel.id && item.rtilCode == this.singChannel.id) {
            this.tvuOne = true;
          }
        });
        if (this.title == 'Me' || this.singChannel.id == this.userInfo.rtilCode) {
          if (this.muteVideo) {
            array = ['rename'];
          } else {
            array = ['fullScreen', 'rename', 'mainwindow'];
          }
        } else {
          if (this.tvuOne) {
            // tvuone 不可以rename
            array = array.filter(featureName => {
              return featureName != 'rename' || featureName != 'startPrivateConversation';
            });
          }
          if (!this.muteVideo) {
            array.unshift('fullScreen');
          }
          if (this.singChannel.id == this.singChannel.shareCode) {
            array = [];
          }
          if (this.sourceType === 'R' || this.sourceType === 'MH') {
            array = array.filter(featureName => {
              return featureName != 'moveParty';
            });
          }
        }
        if (array.includes('moveParty') && this.singChannel.id && !this.State.batchMoveParticipateList.includes(this.singChannel.id)) {
          this.State.batchMoveParticipateList.push(this.singChannel.id);
        }
      }
      if (this.sourceType == 'Web' || this.sourceType === 'Anywhere' || !this.sourceType || this.sourceType === 'App' || this.sourceType === 'MH') {
        array = array.filter(featureName => {
          return featureName != 'setting';
        });
      }
      // 移除anyWhere中的setting
      if (this.sourceType == 'Anywhere' && this.devicePlatform != '12' || this.sourceType == 'App') {
        array.push('anyWhereSetting');
      }
      if (this.outputRtilCode == this.singChannel.id) {
        array = array.map(item => item === 'mainwindow' ? 'unMainwindow' : item);
      }
      return array;
    },
    controlMuteVideo() {
      if (this.talkbackStatus) {
        return this.controlMute;
      } else {
        return '';
      }
    },
    showMoveIcon() {
      return !!(this.title != 'Me' && (this.outputRtilCode != this.singChannel.id || this.outputRtilCode == this.singChannel.id && this.singChannel.id != this.userInfo.rtilCode) && this.singChannel.shareCode != this.singChannel.id && this.State.batchMoveParticipate && this.sourceType !== 'R' && this.sourceType !== 'MH');
    },
    returnVideoClass() {
      let _str = '';
      this.isFullScreen ? _str += 'isFullScreen' : '';
      if (!this.State.showFootBar && this.isFullScreen) {
        _str += ' notShowFootBar';
      }
      return _str;
    }
  },
  watch: {
    selectRids: {
      immediate: true,
      handler(val) {
        this.selectRid = val;
      }
    },
    fullScreenInfo(newVal, oldVal) {
      if (!newVal && oldVal) this.isFullScreen = false;
    },
    allRList(val) {
      if (!this.allRList) return;
      if (this.$route.name === 'party' || this.$route.name === 'partyParticipate') {
        this.newFormatRList(val, true);
      } else {
        this.formatRList(val, true);
      }
    },
    'State.batchMoveParticipate': function (val) {
      if (!val) {
        this.selectPip = false;
      }
    }
  },
  methods: {
    controlLocalSharePlay(shareRtilCode, val) {
      var _this$$refs$attendUse;
      if (shareRtilCode != this.singChannel.id) return;
      (_this$$refs$attendUse = this.$refs.attendUser) === null || _this$$refs$attendUse === void 0 ? void 0 : _this$$refs$attendUse.controlLocalSharePlay(val);
    },
    setSpeaker() {
      this.$refs.attendUser && this.$refs.attendUser.setSpeakerAttendUser();
    },
    callbackByLiveSource({
      type,
      filter,
      rid,
      from,
      val,
      value
    }) {
      if (type == 'getReceiverList' && !filter) {
        if (val) {
          this.getReceiverParams.pageNum = 1;
          this.getRList(filter, from);
        }
      } else if (type == 'getReceiverList' && filter) {
        if (this.getRListTimer) clearTimeout(this.getRListTimer);
        this.getRListTimer = setTimeout(() => {
          this.getRList(filter, from, val);
        }, 500);
      } else if (type == 'changeSource') {
        if (typeof rid === 'string') {
          this.selectRid = rid;
        } else {
          this.selectRid = rid[1];
        }
      } else if (type === 'loadNextPage') {
        var _this$listInfo$cc;
        if ((_this$listInfo$cc = this.listInfo.cc) !== null && _this$listInfo$cc !== void 0 && _this$listInfo$cc.hasNextPage) {
          this.getReceiverParams.pageNum++;
          this.getRList('', from, '', 'loadNextPage');
        }
      } else if (type === 'initPageNum') {
        this.getReceiverParams.pageNum = 1;
      } else if (type == 'startlive') {
        this.$emit('callBack', value);
      }
    },
    controlAudioChannel() {
      if (this.singChannel.id == this.userInfo.rtilCode) {
        this.$refs.attendUser.reUseAudioWorklet();
      }
    },
    changeFullScreenVal(val) {
      var _this$$refs$attendUse2;
      (_this$$refs$attendUse2 = this.$refs.attendUser) === null || _this$$refs$attendUse2 === void 0 ? void 0 : _this$$refs$attendUse2.changeFullScreenVal(val);
    },
    showTalkbackTitle(haveSetTalkback) {
      let _str = '';
      const _this = this;
      haveSetTalkback ? _str = this.$t('commonSetting.offLazyAudioTips') : _str = this.$t('commonSetting.turnOnLazy');
      if (_this.liveInfo.peerId && _this.liveInfo.peerId.includes('fffff')) {
        _str = this.$t('addWords.producerNotSupport');
      }
      return _str;
    },
    lazyAudioCallback(info) {
      const {
        type
      } = info;
      if (type === 'setTalback') {
        this.setTalkback();
      }
    },
    setTalkback() {
      const params = {
        partyCode: this.userInfo.joinCode,
        module: this.talkBackInfo[this.singChannel.id] ? 'cancelParticipantTalkBack' : 'setParticipantTalkBack',
        msg: {
          rtilCode: this.singChannel.id,
          receiverId: this.liveInfo.peerId,
          initiator: this.userInfo.rtilCode
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=37589', params).then(res => {
        const {
          errorCode
        } = res.data.result;
        if (errorCode === '0x0') {
          this.talkBackInfo[this.singChannel.id] ? this.$message.success(this.$t('commonSetting.rOutputToR')) : this.$message.success(this.$t('commonSetting.lOutputToR'));
        }
      });
    },
    moveParty(val) {
      this.$emit('operatCallback', {
        type: 'moveParty',
        id: this.singChannel.id,
        status: val,
        sign: 'batch'
      });
    },
    attendCallback(obj) {
      const {
        type,
        val
      } = obj;
      if (type === 'fullScreen') {
        this.isFullScreen = val;
      }
      this.$emit('operatCallback', obj);
    },
    getRList(filter, from, val, loadNextPage) {
      let params = null;
      if (filter) {
        params = {
          living: true,
          offline: false,
          online: true,
          queryCollaborate: true,
          condition: val
        };
      } else {
        params = this.getReceiverParams;
      }
      this.axios.post('/partyline-backend/receiver/v3/page', params).then(res => {
        if (!res) return;
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          this.listInfo = result;
          if (from) {
            this.newFormatRList(result, filter, loadNextPage);
          } else {
            this.formatRList(result);
          }
          this.$emit('changeRList', result);
        }
      });
    },
    dealPPList(list) {
      const array = [];
      this.State.ppRlist = [];
      list.forEach(item => {
        item.pageInfo.list.forEach(info => {
          this.State.slotList = info.ridSlotList;
          this.State.ppRlist.push(info);
          const ppObj = {};
          ppObj.value = info.receiverId;
          ppObj.label = info.name;
          ppObj.userInfo = item.user;
          ppObj.productionId = info.id;
          if (info.ridSlotList) {
            ppObj.children = info.ridSlotList.map((item, index) => {
              return {
                value: item.rid,
                label: `Slot${item.slotNo.replace('s', '')}`
              };
            });
          }
          array.push(ppObj);
        });
      });
      return array;
    },
    // 封装多级联动需要的数据
    newFormatRList(result, filter, loadNextPage) {
      var _result$cc, _result$cc$list;
      if (JSON.stringify(result) == '{}') return;
      const array = [];
      result = JSON.parse(JSON.stringify(result));
      // receiver list
      const receiverObj = {};
      if (loadNextPage) {
        receiverObj.children = this.receiverList[0].children;
      } else {
        this.State.ccIdList = [];
        receiverObj.children = [];
      }
      receiverObj.value = 'Receiver';
      receiverObj.label = 'Receiver';
      if ((_result$cc = result.cc) !== null && _result$cc !== void 0 && (_result$cc$list = _result$cc.list) !== null && _result$cc$list !== void 0 && _result$cc$list.length) {
        result.cc.list.forEach(item => {
          this.State.ccIdList.push(item.peerId);
          const itemInfo = {
            ...item,
            value: item.peerId,
            label: item.name
          };
          receiverObj.children.push(itemInfo);
        });
      } else {
        receiverObj.disabled = true;
      }
      // 最新需求 R 也可以添加成为与会者, 所以需要把当前的 R 从列表中删除
      if (this.sourceType === 'R') {
        receiverObj.children = receiverObj.children.filter(item => item.peerId !== this.singChannel.devicePeerId);
      }
      array.push(receiverObj);
      // pp list
      this.State.slotList = [];
      const ppObj = {};
      ppObj.value = 'Producer';
      ppObj.label = 'Producer';
      if (result.pps && result.pps.length) {
        ppObj.children = this.dealPPList(result.pps);
      } else {
        ppObj.disabled = true;
      }
      array.push(ppObj);
      this.receiverList = array;
    },
    formatRList(result, showSelect) {
      var _result$cc2, _result$pp, _result$cc3;
      result = JSON.parse(JSON.stringify(result));
      if ((_result$cc2 = result.cc) !== null && _result$cc2 !== void 0 && _result$cc2.total) {
        this.State.ccIdList = [];
        this.State.ccIdList = result.cc.list.map(v => v.peerId);
      }
      if (result.cc) {
        result.cc.label = 'Receiver';
      }
      this.receiverList = [];
      this.State.slotList = [];
      let slots = [];
      if ((_result$pp = result.pp) !== null && _result$pp !== void 0 && _result$pp.list.length) {
        result.pp.list.forEach(v => {
          v.peerId = v.receiverId;
          this.State.slotList.push(v.rids);
          result.pp.slots = v.rids.map((val, key) => {
            return {
              name: `${v.name}-Slot${key + 1}`,
              peerId: val,
              id: v.id
            };
          });
          slots = result.pp.slots.concat(slots);
        });
        this.receiverList.push({
          label: 'Producer',
          options: slots
        });
      }
      if ((_result$cc3 = result.cc) !== null && _result$cc3 !== void 0 && _result$cc3.list.length) {
        this.receiverList.push({
          label: 'Receiver',
          options: result.cc.list
        });
        // 这步是为了发送websocket里面要更新的list是完整的，有可能getVideoType里面返回的列表不全
        if (showSelect) {
          this.$emit('changeSourceList', result.cc.list);
        }
      }
    }
  }
};